import { LoaderBar } from 'components';
import { Layout } from 'layout';
import React, { createContext, useState, useContext, useEffect, useMemo } from 'react'
import { Navigate, useLocation } from 'react-router-dom';
import { AuthService, buildSignInUrlWithReturn, needsPhoneOnboarding, phoneOnboardingPath } from 'utility';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const setData = () => {
        const authenticated = AuthService.isAuthenticated()
        setIsAuthenticated(authenticated);
        if (authenticated) {
            const user = AuthService.getUser();
            setUser(user);
        } else if (process.env.REACT_APP_MODE === 'TESTING') {
            setUser({
                IsSuperAdmin: true,
                Capabilities: {
                    CanManageMenuDefaults: true,
                },
                PermissionKeys: [
                    'inspections.mine.view',
                    'templates.list.view',
                    'reports.consolidated.view',
                    'reports.custom.view',
                    'mobile.qr.generate.view',
                    'mobile.download.view',
                    'admin.menu-defaults.view',
                ],
            });
            setIsAuthenticated(true);
        }
    }

    const loadToken = async () => {
        setData();
        setLoading(false)
    }

    useEffect(() => {
        loadToken()
    }, [])

    const login = (data) => {
        AuthService.storeToken(data.Token)
        AuthService.storeUser(data)
        setUser(data);
        setIsAuthenticated(true);
    }

    const logout = () => {
        AuthService.logout();
        setIsAuthenticated(false);
        setUser(null);
    }

    const updateUser = (updatedUserData) => {
        AuthService.storeUser(updatedUserData);
        setUser(updatedUserData);
    }

    const contextData = useMemo(() => ({
        loading,
        user,
        isAuthenticated,
        login,
        logout,
        updateUser,
        unique_id: user?.unique_id,
    }), [loading, user, isAuthenticated, login, logout, updateUser])

    return (
        <AuthContext.Provider value={contextData}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => useContext(AuthContext)

export const ProtectRoute = ({ children }) => {
    const { isAuthenticated, loading, user } = useAuth();
    const location = useLocation();
    if (loading) {
        return <LoaderBar />
    }
    if (!isAuthenticated) {
        const signInUrl = buildSignInUrlWithReturn(
            location.pathname,
            location.search,
        )
        return <Navigate to={signInUrl} replace />
    }
    if (needsPhoneOnboarding(user)) {
        return <Navigate to={phoneOnboardingPath(`${location.pathname}${location.search || ''}`)} replace />
    }

    return (<Layout>
        {children}
    </Layout>)
}
